<template>
    <div class="lb-info-wrapper is-relative">
        <div class="lb-ranking-wrapper">
            <p
                :key="ranking.position"
                class="lb-ranking-box has-text-centered title is-4 has-background-primary-light"
            >
                <span class="is-size-6 has-text-weight-normal">RANKING</span>
                <br />
                <span
                    class="is-size-5 has-text-weight-bold"
                >{{ ranking.position }}º / {{ranking.users}}º</span>
            </p>
        </div>
        <app-animation
            v-if="showConfettiAnimation"
            :loop="false"
            :overlay="false"
            :animation="confettiAnimation"
            class="confettiAnimation"
            @complete="showConfettiAnimation = false"
        />
        <div class="lb-score-wrapper">
            <p
                :key="score"
                class="lb-score-box rounded-box has-text-centered title is-4 has-background-white"
            >{{ score }} pt</p>
        </div>
        <div class="lb-question-wrapper">
            <p
                :key="questions.total"
                class="lb-question-box has-text-centered title is-4 has-background-primary-light"
            >
                <span
                    class="is-size-6 has-text-weight-normal is-uppercase"
                >{{$t('Sessions.questions')}}</span>
                <br />
                <span
                    class="is-size-5 has-text-weight-bold"
                >{{ questions.answered }} / {{questions.total}}</span>
            </p>
        </div>
    </div>
</template>

<script>
import AppAnimation from '@/components/AppAnimation';
export default {
    components: {
        AppAnimation,
    },
    props: {
        score: {
            type: Number,
            default: 0,
        },
        ranking: {
            type: Object,
            default: {},
        },
        questions: {
            type: Object,
            default: {},
        },

    },
    data() {
        return {
            showConfettiAnimation: true,
            confettiAnimation: require('@/assets/animations/confetti.json'),
        };
    },
    watch: {
        score() {
            this.showConfettiAnimation = true;
        },
    },
    mounted() {
        console.log("ranking",this.ranking)
        console.log("questions",this.questions)
    }
};
</script>

<style scoped>
.lb-info-wrapper {
    width: 320px;
    height: 120px;
}
.lb-score-box {
    width: 90px;
    height: 90px;
    display: table-cell !important;
    vertical-align: middle;
    padding: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.lb-score-box-wrapper {
    width: 120px;
    height: 120px;
}
.lb-score-wrapper {
    padding-top: 0;
    padding-left: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 113px;
    width: 95px;
    height: 95px;
    z-index: 1;
}
.lb-ranking-wrapper {
    margin-top: 15px;
    padding-top: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 125px;
    height: 120px;
}
.lb-ranking-box {
    width: 155px;
    height: 60px;
    display: table-cell !important;
    vertical-align: middle;
    padding: 0;
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.lb-question-wrapper {
    margin-top: 15px;
    padding-top: 0;
    padding-left: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 192px;
    width: 125px;
    height: 120px;
}
.lb-question-box {
    width: 155px;
    height: 60px;
    display: table-cell !important;
    vertical-align: middle;
    padding: 0;
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.confettiAnimation {
    width: 120px;
    height: 120px;
    left: 115px;
    position: absolute;
    bottom: 15px;
}
</style>